import { forwardRef } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { SwitcherMenuItem } from "lib/@components/nav-switcher/switcher-menu-item"
import { ApplicationIcon } from "./application-icon"

export const ApplicationMenuItem = forwardRef(function ApplicationMenuItem(
    { item, index, previous: __previous, next: __next, last: __last, remove: __remove, ...props },
    ref
) {
    const { selectApplication, closeSwitcher } = useBoundContext()

    return (
        <SwitcherMenuItem
            ref={ref}
            id={`app-${item.id}`}
            index={index}
            dataCy={`application-menu-item-${item.id}`}
            icon={<ApplicationIcon appId={item.id} icon={item.icon} width={40} height={40} />}
            label={item.name}
            accessibleLabel={`Change application to ${item.name}`}
            onSelect={select}
            {...props}
        />
    )

    function select() {
        selectApplication(item.id)
        closeSwitcher()
    }
})
